import React from 'react'

import { toTitleCase } from '../../../../utils/toTitleCase'
import avatar from '../../../../assets/svg/avatar.svg'

import './TopperCard.css'

function TopperCard({ name, photo, semester, result }) {
    return (
        <div className='topperCard'>
            <img className='topperCard_img' src={photo ? photo : avatar} alt='' />
            <h1>{toTitleCase(name && name)}</h1>
            <h3>Semester {semester}</h3>
            <h4>{result}</h4>
        </div>
    )
}

export default TopperCard